export const pads   =  {///////////////

///warehouse
warehousepurchase_form_signature: {
	wasSelectHtml:  false,
	html:           undefined,
	canvas:         undefined,
	label:          'Warehouse Signature',
	pad:            undefined,
},

///staff desk
	goku_form_signature: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Goku Signature Label',
		  pad:             undefined,
	},	

	goku_form_stepper_signatureTest: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'label title - SGINATRUE STEPPER',
		  pad:            undefined,
	},	

	services_form_N_nurseSignature: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Aid Signature',
		  pad:            undefined,
	},	

	services_form_N_patientSignature: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Patient Signature',
		  pad:            undefined,
	},	




///nurse app
	punchout_fullcont_sinagureNurse: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Patient or Guardian',
		  pad:            undefined,
	},	


	punchout_fullcont_sinagurePatient: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Patient',
		  pad:             undefined,
	},	


	clockview_fullcont_sinagurePatient: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Patient',
		  pad:             undefined,
	},	

	clockview_fullcont_sinagureNurse: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Aid',
		  pad:             undefined,
	},	

	timesheet_fullcont_sinagureNurse: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Aid',
		  pad:             undefined,
	},	


	timesheet_fullcont_sinagurePatient: { 
		  wasSelectHtml:  false,
		  html:           undefined,
		  canvas:         undefined,
		  label:          'Patient',
		  pad:             undefined,
	},	
	


}/**/

	

/*



*/